import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MainWebContent from '@/views/platforms/web/MainWebContent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainAplicationContent',
  setup(__props) {

let Content:any = null;









Content = MainWebContent;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Content), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})